export default [
    {
        path: '/joinAtourLicht',
        component: () => import(/* webpackChunkName:"joinAtourLicht"*/'@/pages/joinAtourLicht/index.vue'),
        name: 'joinAtourLicht',
        meta: {
            title: '轻居加盟',
        },
    },
];
